import { defineMessages } from 'react-intl';

export default defineMessages({

    claimInformation: {
        id: 'ax_servicerequest.views.new-service-request.details.claim-details.title',
        defaultMessage: 'Claim information'
    },
    claimNumber: {
        id: 'ax_servicerequest.views.new-service-request.claim-number',
        defaultMessage: 'Claim number'
    },
    createServicePageTitle: {
        id: 'ax_servicerequest.views.new-service-request.details.title',
        defaultMessage: 'New service information'
    },
    relatedTo: {
        id: 'ax_servicerequest.views.new-service-request.related-to',
        defaultMessage: 'Related to'
    },
    serviceToDo: {
        id: 'ax_servicerequest.views.new-service-request.service-code',
        defaultMessage: 'Service to do'
    },
    atentionType: {
        id: 'ax_servicerequest.views.new-service-request.service-kind',
        defaultMessage: 'Atention type'
    },
    atentionLocation: {
        id: 'ax_servicerequest.views.new-service-request.service-address',
        defaultMessage: 'Service address'
    },
    enterNewAddress: {
        id: 'ax_servicerequest.views.new-service-request.new-address',
        defaultMessage: '|Enter new address|'
    },
    completionDate: {
        id: 'ax_servicerequest.views.new-service-request.service-completion-date',
        defaultMessage: 'Completion date'
    },
    commentsObservations: {
        id: 'ax_servicerequest.views.new-service-request.service-comments',
        defaultMessage: 'Comments / Observations'
    },
    createService: {
        id: 'ax_servicerequest.views.new-service-request.createService',
        defaultMessage: 'Create service'
    },
    cancelService: {
        id: 'ax_servicerequest.views.new-service-request.cancelService',
        defaultMessage: 'Cancel'
    },
    confirmCreateService: {
        id: 'ax_servicerequest.views.new-service-request.confirmCreateService',
        defaultMessage: 'Are you sure to create a new service for the claim {claimNumber}?'
    },
    confirmCancelService: {
        id: 'ax_servicerequest.views.new-service-request.confirmCancelService',
        defaultMessage: 'Are you sure you want to cancel?'
    },
    selectOptionDefault: {
        id: 'ax_servicerequest.views.selectdropdpwn.defaultOption',
        defaultMessage: '-- Choose option --'
    },
    errorValidate: {
        id: 'ax_servicerequest.views.new-service-request.errorValidate',
        defaultMessage: 'Required data'
    },
    errorMessageValidate: {
        id: 'ax_servicerequest.views.new-service-request.errorMessageValidate',
        defaultMessage: 'Please enter all requerid data (*)'
    },
    createServiceSuccess: {
        id: 'ax_servicerequest.views.new-service-request.createServiceSuccess',
        defaultMessage: 'Service created'
    },
    createServiceSuccessMessage: {
        id: 'ax_servicerequest.views.new-service-request.createServiceSuccessMessage',
        defaultMessage: 'Service created successful: {serviceRequestNumber}'
    },
    createServiceError: {
        id: 'ax_servicerequest.views.new-service-request.createServiceError',
        defaultMessage: 'Error creating service'
    },
    createServiceErrorMessage: {
        id: 'ax_servicerequest.views.new-service-request.createServiceErrorMessage',
        defaultMessage: 'Error creating service, please contact with the administrator'
    },
    cancelConfirmYes: {
        id: 'ax_servicerequest.views.new-service-request.cancel.Yes',
        defaultMessage: 'Yes'
    },
    cancelConfirmNo: {
        id: 'ax_servicerequest.views.new-service-request.cancel.No',
        defaultMessage: 'No'
    },
});
